<script lang="ts">
    export let text : string;
</script>

<h2 class="headline">{text}</h2>
